const UPDATE_HIGHCHARTS = 'UPDATE_HIGHCHARTS';

function updateHighcharts(id, highchart) {
  return { type: UPDATE_HIGHCHARTS, id, highchart };
}

function update(state, id, highchart) {
  return { ...state, [id]: highchart };
}

export { UPDATE_HIGHCHARTS, updateHighcharts, update };
